var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDeposit)?_c('div',{class:{ 'ssu-deposit': true, single: _vm.single }},[_vm._v(" "+_vm._s(_vm.depositInfo)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }